'use strict';

import resizeStore from '../resize/resize.store';
import scrollStore from './scroll.store';

let html = document.documentElement;
let device;
let headerHidden = false;
let headerScrollHeight = 80;

let scrolled = 0;
let tmpScrolled = 0;
let scrollPoint = false;
let header;



function _handleResize (e) {
  let tmpDevice;

  if (e.width < 740) {
    tmpDevice = 'mobile';
    headerScrollHeight = 60;
  } else {
    tmpDevice = 'desktop';
    headerScrollHeight = 80;
  }

  if (tmpDevice === device) return;

  device = tmpDevice;

  _handleScroll(scrollStore.getData());
}



function _handleScroll () {
  scrolled = window.scrollY;

  if (scrolled > tmpScrolled) {
    if (headerHidden && scrolled < headerScrollHeight || scrolled < 100) {
      html.classList.remove('headerHidden');
      headerHidden = false;
    } else if (!headerHidden && scrolled >= headerScrollHeight) {
      html.classList.add('headerHidden');
      headerHidden = true;
    // } else if (headerHidden && scrolled < headerScrollHeight) {

    }
    scrollPoint = false;
  } else {
    if (!scrollPoint) scrollPoint = scrolled;

    if (headerHidden && (scrollPoint - scrolled >= headerScrollHeight || scrolled <= headerScrollHeight) || scrolled < 100) {
      html.classList.remove('headerHidden');
      headerHidden = false;
    }
  }
  
  tmpScrolled = scrolled;
}



function init() {
  header = document.querySelector('header');
  if (!header) return;

  _handleResize(resizeStore.getData());
  resizeStore.eventEmitter.subscribe(_handleResize);

  scrollStore.eventEmitter.subscribe(_handleScroll);
}


export default {
  init: init
}
